import React from "react";

export default function EspacePersonnel() {
    return (
        <main style={{
            minHeight: "100%",
            padding: "28px",
            background: "#F4F1EA",
            color: "#122A26",
        }}>
            <section style={{
                maxWidth: "980px",
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
            }}>
                <p style={{ margin: 0, color: "#5A6D68", fontSize: "13px", fontWeight: 800, textTransform: "uppercase" }}>
                    Espace personnel
                </p>
                <h1 style={{ margin: 0, fontSize: "30px", color: "#0C3B3C" }}>Espace personnel</h1>
                <p style={{ margin: 0, maxWidth: "620px", color: "#5A6D68", fontSize: "15px", lineHeight: 1.55 }}>
                    Cet espace est prêt à recevoir les contenus qui seront définis plus tard.
                </p>
            </section>
        </main>
    );
}
